var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 59.8 59.5",
    viewBox: "0 0 59.8 59.5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "paperCircleBkg",
    cx: 30,
    cy: 30,
    r: 25.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m33.4 58.1c-0.1-0.8 0.4-1.6 1.2-1.7 0.8-0.2 1.6 0.4 1.7 1.2s-0.4 1.6-1.2 1.7h-0.3c-0.6 0.1-1.2-0.4-1.4-1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m22.6 58.9c-0.8-0.2-1.3-1-1.1-1.8s1-1.3 1.8-1.1 1.3 1 1.1 1.8c-0.2 0.7-0.8 1.1-1.4 1.1h-0.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m44.7 54.2c-0.5-0.7-0.3-1.6 0.4-2.1s1.6-0.3 2.1 0.4 0.3 1.6-0.4 2.1c-0.3 0.2-0.6 0.3-0.9 0.3-0.4 0-0.9-0.2-1.2-0.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m11.4 53.3c-0.6-0.5-0.8-1.5-0.2-2.1 0.5-0.7 1.5-0.8 2.1-0.2 0.6 0.5 0.8 1.5 0.2 2.1-0.3 0.4-0.7 0.6-1.2 0.6-0.3-0.1-0.6-0.2-0.9-0.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m53.4 46c-0.7-0.4-0.9-1.4-0.5-2.1s1.4-0.9 2.1-0.5 0.9 1.3 0.5 2.1c-0.3 0.5-0.8 0.7-1.3 0.7-0.3 0.1-0.6 0-0.8-0.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m3.5 43.6c-0.4-0.7-0.1-1.6 0.6-2s1.6-0.1 2 0.7c0.4 0.7 0.1 1.6-0.6 2-0.2 0.1-0.5 0.2-0.7 0.2-0.5-0.1-1.1-0.4-1.3-0.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m57.9 35c-0.8-0.1-1.4-0.9-1.3-1.7s0.9-1.4 1.7-1.3 1.4 0.9 1.3 1.7-0.7 1.3-1.5 1.3h-0.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m0.2 31.5c0-0.8 0.6-1.5 1.4-1.6 0.8 0 1.5 0.6 1.6 1.4 0 0.8-0.6 1.5-1.4 1.6h-0.1c-0.8 0-1.4-0.6-1.5-1.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m55.6 22.1c-0.2-0.8 0.2-1.6 1-1.9 0.8-0.2 1.6 0.2 1.9 1 0.2 0.8-0.2 1.6-1 1.9-0.2 0.1-0.3 0.1-0.4 0.1-0.7 0-1.3-0.5-1.5-1.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m3.1 21c-0.8-0.3-1.1-1.2-0.8-1.9 0.3-0.8 1.2-1.1 1.9-0.9 0.8 0.3 1.1 1.2 0.8 2-0.2 0.6-0.8 1-1.4 1-0.1 0-0.3-0.1-0.5-0.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m50.1 12.3c-0.5-0.6-0.5-1.6 0.1-2.1s1.6-0.5 2.1 0.1 0.5 1.6-0.1 2.1c-0.3 0.2-0.6 0.4-1 0.4s-0.8-0.2-1.1-0.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m9.2 10.8c-0.6-0.6-0.6-1.6 0-2.1 0.6-0.6 1.5-0.6 2.1 0s0.6 1.5 0 2.1c-0.3 0.3-0.7 0.4-1.1 0.4s-0.7-0.1-1-0.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m41 5.6c-0.8-0.4-1.1-1.2-0.7-2 0.3-0.8 1.2-1.1 2-0.8s1.1 1.2 0.8 2c-0.2 0.6-0.8 0.9-1.4 0.9-0.3 0-0.5 0-0.7-0.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m18.9 3.9c-0.3-0.8 0.1-1.6 0.9-1.9s1.6 0.1 1.9 0.9-0.1 1.6-0.9 1.9c-0.2 0.1-0.3 0.1-0.5 0.1-0.6 0-1.2-0.4-1.4-1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "m28.5 1.7c0-0.8 0.7-1.5 1.5-1.5s1.5 0.7 1.5 1.5-0.7 1.5-1.5 1.5-1.5-0.7-1.5-1.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "paperIconOutline",
    d: "M20.8,18.6v24.5h11.8c3.7,0,6.6-3,6.6-6.6V18.6H20.8z M38.1,36.5c0,3.1-2.5,5.6-5.6,5.6H21.8V19.6h16.4V36.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "paperIconOutline",
    x: 25.9,
    y: 25.8,
    width: 8.2,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "paperIconOutline",
    x: 25.9,
    y: 29.9,
    width: 8.2,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "paperIconOutline",
    x: 25.9,
    y: 34,
    width: 6.1,
    height: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCircle);
export default __webpack_public_path__ + "static/media/paper-circle.868dbfbcec374ceb2b155452d1a169ea.svg";
export { ForwardRef as ReactComponent };